import { render, staticRenderFns } from "./AddOrModify.vue?vue&type=template&id=79cabf2e&scoped=true"
import script from "./AddOrModify.vue?vue&type=script&lang=js"
export * from "./AddOrModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cabf2e",
  null
  
)

export default component.exports